"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentErrorCatalog = exports.AppointmentErrorCodes = void 0;
exports.getAppointmentErrorCatalogEntry = getAppointmentErrorCatalogEntry;
/**
 * Appointment-specific error codes — namespaced (mostly)
 * `APPOINTMENT_*`/`QUEUE_*`/`WAITLIST_*`/`REMINDER_*`/`DOCTOR_*`,
 * additive and parallel to backend's own `ErrorCodes`/`ErrorCatalog`
 * and to Patient Identity's own `PatientErrorCodes` — this file does
 * not modify either. Same discipline as
 * `patient-error-codes.ts`: every code here maps to a real, named
 * condition already thrown inside a frozen Domain Service (Stage
 * 5B.3) or Application Service (Stage 5B.4), not an invented rule.
 */
exports.AppointmentErrorCodes = {
    APPOINTMENT_SLOT_CONFLICT: 'APPOINTMENT_SLOT_CONFLICT',
    APPOINTMENT_NOT_FOUND: 'APPOINTMENT_NOT_FOUND',
    APPOINTMENT_INVALID_STATUS_TRANSITION: 'APPOINTMENT_INVALID_STATUS_TRANSITION',
    CHECK_IN_VISIT_TYPE_REQUIRED: 'CHECK_IN_VISIT_TYPE_REQUIRED',
    TELEMEDICINE_SESSION_UNAVAILABLE: 'TELEMEDICINE_SESSION_UNAVAILABLE',
    QUEUE_ENTRY_NOT_FOUND: 'QUEUE_ENTRY_NOT_FOUND',
    QUEUE_ENTRY_INVALID_STATUS_TRANSITION: 'QUEUE_ENTRY_INVALID_STATUS_TRANSITION',
    QUEUE_TOKEN_NOT_FOUND: 'QUEUE_TOKEN_NOT_FOUND',
    WAITLIST_DOCTOR_REQUIRED: 'WAITLIST_DOCTOR_REQUIRED',
    DOCTOR_SCHEDULE_NOT_FOUND: 'DOCTOR_SCHEDULE_NOT_FOUND',
    SLOT_HOLD_NOT_FOUND: 'SLOT_HOLD_NOT_FOUND',
    SLOT_HOLD_TOKEN_MISMATCH: 'SLOT_HOLD_TOKEN_MISMATCH',
    REMINDER_NOT_FOUND: 'REMINDER_NOT_FOUND',
    REMINDER_INVALID_STATUS_TRANSITION: 'REMINDER_INVALID_STATUS_TRANSITION',
    SEQUENCE_NOT_CONFIGURED: 'APPOINTMENT_SEQUENCE_NOT_CONFIGURED',
    VALIDATION_ERROR: 'APPOINTMENT_VALIDATION_ERROR',
};
exports.AppointmentErrorCatalog = {
    [exports.AppointmentErrorCodes.APPOINTMENT_SLOT_CONFLICT]: {
        httpStatus: 409,
        description: 'This doctor already has a slot hold or a booking at the requested time (AppointmentSlotHold\'s own unique-constraint guarantee, ADR-023).',
        retryable: true,
    },
    [exports.AppointmentErrorCodes.APPOINTMENT_NOT_FOUND]: {
        httpStatus: 404,
        description: 'No appointment matches the given id (or is not visible to this tenant).',
        retryable: false,
    },
    [exports.AppointmentErrorCodes.APPOINTMENT_INVALID_STATUS_TRANSITION]: {
        httpStatus: 409,
        description: 'This appointment cannot move to the requested status from its current status.',
        retryable: false,
    },
    [exports.AppointmentErrorCodes.CHECK_IN_VISIT_TYPE_REQUIRED]: {
        httpStatus: 400,
        description: 'The appointment has no clinicalPurposeId and no fallbackVisitTypeId was supplied — a Visit cannot be created without one.',
        retryable: false,
    },
    [exports.AppointmentErrorCodes.TELEMEDICINE_SESSION_UNAVAILABLE]: {
        httpStatus: 400,
        description: 'The requested doctor has no telemedicine-enabled session at the requested time.',
        retryable: false,
    },
    [exports.AppointmentErrorCodes.QUEUE_ENTRY_NOT_FOUND]: {
        httpStatus: 404,
        description: 'No queue entry matches the given id (or is not visible to this tenant).',
        retryable: false,
    },
    [exports.AppointmentErrorCodes.QUEUE_ENTRY_INVALID_STATUS_TRANSITION]: {
        httpStatus: 409,
        description: 'This queue entry cannot move to the requested status from its current status.',
        retryable: false,
    },
    [exports.AppointmentErrorCodes.QUEUE_TOKEN_NOT_FOUND]: {
        httpStatus: 404,
        description: 'No QueueToken has been issued yet for this visit — issue one first.',
        retryable: false,
    },
    [exports.AppointmentErrorCodes.WAITLIST_DOCTOR_REQUIRED]: {
        httpStatus: 400,
        description: 'The waitlist entry has no doctor preference and the promoted slot named no doctor either — a booking cannot be made without one.',
        retryable: false,
    },
    [exports.AppointmentErrorCodes.DOCTOR_SCHEDULE_NOT_FOUND]: {
        httpStatus: 404,
        description: 'No doctor schedule matches the given id (or is not visible to this tenant).',
        retryable: false,
    },
    [exports.AppointmentErrorCodes.SLOT_HOLD_NOT_FOUND]: {
        httpStatus: 404,
        description: 'No slot hold matches the given id.',
        retryable: false,
    },
    [exports.AppointmentErrorCodes.SLOT_HOLD_TOKEN_MISMATCH]: {
        httpStatus: 409,
        description: 'The supplied holdToken does not match — this hold is not owned by the caller.',
        retryable: false,
    },
    [exports.AppointmentErrorCodes.REMINDER_NOT_FOUND]: {
        httpStatus: 404,
        description: 'No reminder matches the given id (or is not visible to this tenant).',
        retryable: false,
    },
    [exports.AppointmentErrorCodes.REMINDER_INVALID_STATUS_TRANSITION]: {
        httpStatus: 409,
        description: 'Only a PENDING reminder can be cancelled — this one has already fired or was already cancelled.',
        retryable: false,
    },
    [exports.AppointmentErrorCodes.SEQUENCE_NOT_CONFIGURED]: {
        httpStatus: 500,
        description: 'No Sequence Engine definition (QUEUE_TOKEN or VISIT_NUMBER) is configured for this tenant/branch — a Platform Engine onboarding gap, not a caller error.',
        retryable: false,
    },
    [exports.AppointmentErrorCodes.VALIDATION_ERROR]: {
        httpStatus: 422,
        description: 'Request body failed schema validation.',
        retryable: false,
    },
};
function getAppointmentErrorCatalogEntry(code) {
    return exports.AppointmentErrorCatalog[code];
}
//# sourceMappingURL=appointment-error-codes.js.map